/** Escala de espaçamento ARIDE (px). */
export const spacingTokens = {
  minimum: 4,
  small: 8,
  base: 12,
  medium: 16,
  large: 24,
  extralarge: 32
} as const;

export type SpacingTokenKey = keyof typeof spacingTokens;

/**
 * Compatível com o uso anterior `theme.spacing(n) => 12 * n` px (MUI Modal, etc.).
 * Para valores da escala explícita, importe `spacingTokens`.
 */
export function spacingFromFactor(factor: number): string {
  return `${spacingTokens.base * factor}px`;
}
